import i18n from 'i18n'
import * as React from 'react'
import { SelectSeeker } from 'ui-seeker/core'

const OPTIONS = [
    {label: 'Hotel A', value: 'a'},
    {label: 'Hotel B', value: 'b'},
    {label: 'Hotel C', value: 'c'},
    {label: 'Hotel D', value: 'd'},
]

export default function SelectHotelChain({...props}) {
    const myProps = {
        placeholder: i18n.t('common:filters.allHotels'),
        firstSelect: true, 
        isClearable: true, 
        options: OPTIONS,
        icon: {icon: 'hotel'},
        isMulti: false,
        ...props
    }

    return <SelectSeeker {...myProps} />
}